import {useContext, useEffect} from "react";
import {useLocation, useNavigate} from "react-router-dom";
import {setLoginBacklink} from "./loginBacklink.js";
import {GlobalContext} from "../../utils/context/GlobalContextProvider.jsx";

export function useRequireLoginEffect() {
    let navigate = useNavigate();
    let location = useLocation();
    let {context} = useContext(GlobalContext);

    useEffect(() => {
        if (context.currentIdentity === null) {
            setLoginBacklink(location.pathname);
            navigate('/sign/in');
        }
    });
}
